"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimelineElement = void 0;
var moment = require("moment");
var milestone_1 = require("../../../schemas/milestone");
var TimelineElement = /** @class */ (function () {
    function TimelineElement(props) {
        if (!props.icon && props.instance) {
            props.icon = TimelineElement.getIcon(props.instance.category);
        }
        this.progress = props.progress;
        this.instance = props.instance;
        this.icon = props.icon;
        this.updated = props.updated;
    }
    TimelineElement.getIcon = function (category) {
        switch (category) {
            case milestone_1.MilestoneType.HEALTH:
            case milestone_1.MilestoneType.GROWTH:
            case milestone_1.MilestoneType.DIET:
            case milestone_1.MilestoneType.EXERCISE:
            case milestone_1.MilestoneType.GROOMING:
            case milestone_1.MilestoneType.HAIR:
            case milestone_1.MilestoneType.NAILS:
            case milestone_1.MilestoneType.TEETH:
            case milestone_1.MilestoneType.MEDICAL:
            case milestone_1.MilestoneType.VETERINARY:
            case milestone_1.MilestoneType.INSURANCE:
                return 'growth';
            case milestone_1.MilestoneType.TRAINING:
            case milestone_1.MilestoneType.WALKING:
            case milestone_1.MilestoneType.SOCIAL:
                return 'brain';
            default:
                return 'help';
        }
    };
    TimelineElement.daysOld = function (dob) {
        return moment()
            .diff(dob, 'days', true);
    };
    TimelineElement.prototype.toJSON = function () {
        return {
            instance: this.instance,
            progress: this.progress,
            icon: this.icon,
            updated: this.updated
        };
    };
    return TimelineElement;
}());
exports.TimelineElement = TimelineElement;
